const urlFields = ['data', 'target', 'name'] as const;

export const stripTelemetryQuery = (value: unknown): unknown => {
  if (typeof value !== 'string' || !value.includes('?')) {
    return value;
  }

  const queryIndex = value.indexOf('?');
  const prefix = value.slice(0, queryIndex);
  return prefix || value;
};

export const sanitizeDependencyBaseData = (baseData: Record<string, unknown>): void => {
  for (const field of urlFields) {
    baseData[field] = stripTelemetryQuery(baseData[field]);
  }
};

export const sanitizeDependencyEnvelope = (envelope: {
  baseType?: string;
  baseData?: Record<string, unknown>;
}): void => {
  if (envelope.baseType === 'RemoteDependencyData' && envelope.baseData) {
    sanitizeDependencyBaseData(envelope.baseData);
  }
};
